import React from 'react';
import Spinner from "react-spinkit";
import { Footer } from '../components/Footer';
const BlogPage = () => (
    <div className="blog-wrapper">
        <Spinner name="folding-cube" />
        <h2> Work in progress... </h2>
    </div>

)

export default BlogPage



// WEBPACK FOOTER //
// ./src/pages/blog.js